import React from 'react';

interface LoadingSpinnerProps {
  className?: string;
  label?: string;
  fullPage?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className = 'h-10 w-10',
  label,
  fullPage = true,
}) => {
  const spinner = (
    <div className="flex flex-col items-center justify-center" role="status">
      <div
        className={`animate-spin rounded-full border-2 border-stone-200 border-t-forest-600 ${className}`}
      />
      {label ? <p className="mt-4 text-sm text-ink-muted">{label}</p> : null}
      <span className="sr-only">Chargement</span>
    </div>
  );

  if (!fullPage) return spinner;

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center px-4">
      {spinner}
    </div>
  );
};

export default LoadingSpinner;
